import React, { useEffect, useState } from "react";
import MUIModal from "../../components/MUIModal";
import { useForm } from "react-hook-form";
import Invoice from "../../components/UI/MakePayment/pdf/invoice";
import { formatDate } from "../../utils/dateUtils";
import globalUtils from "../../utils/globalUtils";
import LoadInvoice from "../BrokerPayments/LoadInvoice";
import { useUpdateOrderMutation } from "../../services/load";
import { toast } from "react-toastify";
import { useLazyGetSingleOrganizationQuery } from "../../services/organization";
import { useGetMeQuery } from "../../services/user";
import { useDispatch } from "react-redux";
import { setBackDropOpen } from "../../store/slice/globalSlice";

const InvoiceSection = ({
	showModal = false,
	setShowModal = () => {},
	load = {},
	customerData = {},
	handleInvoiceDownload = () => {},
}) => {
	const [getOrgById, { data: organizationsData }] = useLazyGetSingleOrganizationQuery();
	const [showModalPaid, setShowModalPaid] = useState(false);
	const [updateLoad] = useUpdateOrderMutation();
	const { data: user } = useGetMeQuery();
	const {
		register,
		watch,
		handleSubmit,
		setValue,
		control,
		formState: { errors },
	} = useForm({
		defaultValues: {
			_id: load._id,
			loadId: load.loadId,
			load_date: formatDate(new Date()),
			load_reference: load.referenceNumber,
			weight: `${globalUtils.getLoadWeight(load)} lbs`,
			company_name: customerData.customerName,
			company_address: customerData.customerAddress,
			company_phone: customerData.customerNumber,
			billing_primary_contact: "",
			billing_primary_phone: "",
			billing_primary_fax: "",
			paytm_description: "Flat Rate",
			paytm_notes: "",
			paytm_quantity: 1,
			paytm_rate: 1 * load.customerRate,
			paytm_amount: load.customerRate,
		},
	});

	useEffect(() => {
		if (user) getOrgById(user.user.organization, true);
	}, [user]);

	useEffect(() => {
		if (load && organizationsData) {
			setValue("address_1", organizationsData.address1);
			setValue("orgName", organizationsData.companyName);
			setValue("address_2", organizationsData.cityStateZip || "");
			setValue("docket", organizationsData.mcNumber || "");
			setValue("phone", organizationsData.phone || "");

			setValue("accountType", organizationsData.accountType || "");
			setValue("depositType", organizationsData.depositType || "");
			setValue("abaRoutingNumber", organizationsData.abaRoutingNumber || "");
			setValue("accountNumber", organizationsData.accountNumber || "");
			setValue("voidedCheck", organizationsData.voidedCheck || "");
		}
	}, [load, organizationsData]);

	const dispatch = useDispatch();

	const onSubmit = async (data) => {
		dispatch(setBackDropOpen(true));
		const date = data.lastDate;
		data.lastDate = date.format("MM/DD/YYYY, hh:mm A");
		const formData = {
			brokerPaymentStatus: load.customer && load.customer.isApproved ? "Factored" : "Invoiced",
			brokerInvoicedInfo: {
				lastDate: data.lastDate,
			},
		};
		await updateLoad({ id: load._id, payload: formData });
		dispatch(setBackDropOpen(false));
		setShowModalPaid(false);
		toast("Load payment status updated successfully!");
		handleInvoiceDownload(data, organizationsData, formData.brokerPaymentStatus);
	};
	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<MUIModal
				showModal={showModal}
				setShowModal={setShowModal}
				modalTitle={"Edit Invoice"}
				closeBtn="Cancel"
				secondaryBtnText={"Update And Create Inovice"}
				handleClickSecondaryBtn={handleSubmit(onSubmit)}
				isSubmit={true}
				modalClassName="wd-80"
				modalBodyComponent={
					<Invoice
						setValue={setValue}
						register={register}
						errors={errors}
						watch={watch}
						control={control}
						load={load}
					/>
				}
			/>
			<MUIModal
				showModal={showModalPaid}
				setShowModal={setShowModalPaid}
				modalTitle="Load Paid"
				modalClassName="wd-65"
				isFooter={false}
				modalBodyComponent={<LoadInvoice currentData={load} setShowModalPaid={setShowModalPaid} />}
			/>
		</form>
	);
};

export default InvoiceSection;
